import { Modal } from 'antd'
import sensors from '../../../../utils/sensors'
import { MODAL_CONFIGS } from './paymentConfig'
import { GoodsItem } from '../types'
import CONFIG from '../../../../constants/config'

export interface ValidationResult {
  allowed: boolean
  type?: 'svip' | 'vvip'
}

/**
 * 商品选择验证逻辑
 */
export const validateGoodsSelection = (
  item: GoodsItem,
  paymentStatus: any,
  sourceDetail: string,
  svipOnlyText: any
): ValidationResult => {
  const defaultSVIP = paymentStatus.vipKind === CONFIG.VIP_KIND.SVIP

  // SVIP限制检查
  if (
    defaultSVIP &&
    item.content.vipKind !== CONFIG.VIP_KIND.SVIP &&
    paymentStatus.onlySvip
  ) {
    return { allowed: false, type: 'svip' }
  }

  // VVIP限制检查
  if (
    item.content.vipKind === CONFIG.VIP_KIND.VIP &&
    paymentStatus.onlyVVip &&
    sourceDetail !== 'menuResidentEntrance'
  ) {
    return { allowed: false, type: 'vvip' }
  }

  return { allowed: true }
}

/**
 * 显示商品限制弹窗
 */
export const showRestrictionModal = (
  type: 'svip' | 'vvip',
  content: string,
  sourceDetail: string,
  onConfirm: () => void
) => {
  const config =
    type === 'svip'
      ? MODAL_CONFIGS.SVIP_RESTRICTION
      : MODAL_CONFIGS.VVIP_RESTRICTION

  const trackActionType = type === 'svip' ? 'clickBuy' : undefined

  Modal.info({
    ...config,
    content,
    onOk: () => {
      if (trackActionType) {
        sensors.track('web_get_action_workgroup_vip_need_svip', {
          actionType: trackActionType,
          source_detail: sourceDetail
        })
      }
      onConfirm()
      Promise.resolve()
    }
  })
}

/**
 * 处理商品选择
 */
export const handleGoodsSelection = (
  item: GoodsItem,
  validation: ValidationResult,
  paymentStatus: any,
  sourceDetail: string,
  svipOnlyText: any,
  onSuccess: (item: GoodsItem) => void
) => {
  if (!validation.allowed && validation.type) {
    const content =
      validation.type === 'svip'
        ? svipOnlyText[sourceDetail] || svipOnlyText.default
        : MODAL_CONFIGS.VVIP_RESTRICTION.content

    showRestrictionModal(validation.type, content, sourceDetail, () =>
      onSuccess(item)
    )
  } else {
    onSuccess(item)
  }
}
